const getSlickSettings = (cardsNumber , variant = 'default') => {
const fleetsSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: false,
    arrows: cardsNumber?  cardsNumber >= 4 ? true : false : true,
    infinite: cardsNumber >= 4 ? true : false,
    // variableWidth: true,
    dots: false,

    responsive: [
      {
        breakpoint: 992,
        settings: {
    slidesToShow: cardsNumber ? cardsNumber >= 3 ? 3 : cardsNumber: 3,
          slidesToScroll: 3,
          infinite: cardsNumber > 3,
          // variableWidth: cardsNumber < 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: cardsNumber > 2 ? true : false,
          dots: false,
          infinite: cardsNumber > 2 ? true : false,
          // variableWidth:cardsNumber < 2 ,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: cardsNumber > 1,
          dots: false,
          infinite: cardsNumber > 1,
          variableWidth: false,
        },
      },
    ]
}
const CompaniesSettings = {
    slidesToShow: 11,
    slidesToScroll: 3,
    autoplay: true,
    infinite: true,
    dots: false,
    pauseOnHover: false,
    speed: 10000,
    autoplaySpeed: 1,
    centerMode: false,
    cssEase: 'linear',
    initialSlide: 0,
    arrows: false,
    buttons: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  }

  const variants = {
    infiniteCompamies : CompaniesSettings,
    default: fleetsSettings
  }
return variants[variant] || fleetsSettings
  }

  export default getSlickSettings